import { AtIconInformative, AtIconInformativeProps } from '../../atoms'
import { cn } from '../../utils'
import { Media, OrMedia } from '../or-media'

export interface OrContentBlockGProps {
  title: string
  subTitle?: string
  informative?: AtIconInformativeProps[]
  media?: Media[]
}

export const OrContentBlockG = ({ title, subTitle, informative, media }: OrContentBlockGProps) => {
  return (
    <section className="mx-auto w-full lg:max-w-screen-lg">
      <div>
        <h2 className="text-neutrals-900 text-24 slg:text-32 font-heading font-medium leading-[1.95rem] slg:leading-[2.4rem]">
          {title}
        </h2>
        {subTitle ? <p className="text-neutrals-700 text-16 font-regular leading-6">{subTitle}</p> : null}
      </div>
      <div className="mt-8 grid slg:grid-cols-2 slg:gap-x-7.5 slg:gap-y-6">
        {informative?.map((content, index) => (
          <div
            className={cn('odd:mb-7.5 even:mb-6 last:!mb-0', 'slg:odd:mb-0 slg:even:mb-0 slg:last:!mb-0')}
            key={index}
          >
            <AtIconInformative
              className="flex flex-row !gap-0 slg:!gap-2"
              {...content}
              titleClass="font-heading lg:text-24 text-20 leading-[1.625rem] font-medium text-neutrals-800 slg:text-24 slg:leading-[1.95rem]"
              labelClass="text-16 font-regular"
              contentClass="pr-1 pt-1"
            />
          </div>
        ))}
      </div>
      <div className="mt-12">
        {media && media.map((item) => <OrMedia {...item} key={item.src} className="!h-[512px]" />)}
      </div>
    </section>
  )
}
